import * as React from 'react';
import { Button } from 'react-covideo-common';
import styled, { css } from 'styled-components/macro';

const Switch = styled.div<{ disabled?: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 4px;
  border-radius: 6px;
  border: solid 1px #d0d3d9;
  background-color: rgba(0, 27, 83, 0.05);
  display: flex;
  align-items: center;
  & > span {
    margin: 12px;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      > button {
        opacity: 0.5;
      }
    `}
`;

const NonSelectedBtn = styled.span`
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #9297a2;
  cursor: pointer;
  flex: 1;
`;

type SelectedButtonProps = {
  width: string;
};
const SelectedButton = styled.div<SelectedButtonProps>`
  button {
    width: ${props => props.width};
  }
  flex: 1;
`;

type Value = {
  text: string;
  value: string;
  width?: string;
};
type Props = {
  defaultValue: string;
  onChange: (value: string) => void;
  values: Value[];
  className?: string;
  disabled?: boolean;
};

export const ButtonSwitch = (props: Props) => {
  const { defaultValue, values, onChange, className } = props;
  const [value, setValue] = React.useState(defaultValue);

  React.useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <Switch
      {...(className && { className: className })}
      disabled={props.disabled}
    >
      {values.map(btn => {
        if (btn.value === value) {
          return (
            <SelectedButton width={btn.width || '100%'} key={btn.value}>
              <Button text={btn.text} size='small' />
            </SelectedButton>
          );
        }
        return (
          <NonSelectedBtn
            key={btn.value}
            onClick={() => {
              setValue(btn.value);
              onChange(btn.value);
            }}
          >
            {btn.text}
          </NonSelectedBtn>
        );
      })}
    </Switch>
  );
};
